var map = {
	"./portrait_en.png": "GLCp",
	"./portrait_fr.png": "qxbt"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "F+i2";


//////////////////
// WEBPACK FOOTER
// ./src/components/world/elements/img ^\.\/portrait_.*\.png$
// module id = F+i2
// module chunks = 0